export default angular
  .module("ShowAuditLogCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ShowAuditLogController", [
    "$scope",
    "$modalInstance",
    "Scripts",
    "resourceId",
    function (
      $scope,
      $modalInstance,
      Scripts,
      resourceId,
    ) {
      $scope.ok = function () {
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      $scope.auditLogPageSize = 10;
      Scripts.loadAuditLogById(resourceId, (data) => {
        $scope.auditlog = data;
      });
    },
  ]);
